import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MangoCoreModule } from '@mango/core';
import { MaterialModule } from '../modules/material.module';
import { ItemTileComponent } from './components/item-tile/itemtile.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AuthorizationModule } from '@mango/authorization';
import { UserCollectionComponent } from '../user/user-collection.component';
import { UserFilterComponent } from '../user/user-filter.component';
import { RouterModule } from '@angular/router';
import { BaseLayoutComponent } from './components/base-layout/base-layout.component';
import { AlertsPopupComponent } from './components/alert-popup/alert-popup.component';
import { componentsExtra } from '../components-extra';
import { components } from '../components';
import { AuthenticationModule, AuthGuardModule, JwtModule } from '@mango/authentication';
import { MatMomentDatetimeModule } from '@mat-datetimepicker/moment';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';


const sharedCollections = [
    
]

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MangoCoreModule.forRoot(),
        MaterialModule,
        HttpClientModule,
        FlexLayoutModule,
        JwtModule,
        AuthGuardModule,
        AuthenticationModule,
        RouterModule,
        AuthorizationModule.forRoot({ UserCollectionComponent: UserCollectionComponent, UserFilterComponent: UserFilterComponent, userDetailRouterLink: '/users/detail' }),
        MatMomentDatetimeModule,
        MatDatetimepickerModule,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule

    ],
    declarations: [
        ItemTileComponent,
        BaseLayoutComponent,
        AlertsPopupComponent,
        componentsExtra,

        sharedCollections,
        components 
    ],
    providers: [],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MangoCoreModule,
        MaterialModule,
        ItemTileComponent,
        RouterModule,
        
        HttpClientModule,
        FlexLayoutModule,
        JwtModule,
        AuthGuardModule,
        AuthenticationModule,
        AuthorizationModule,
        AlertsPopupComponent,
        componentsExtra,

        sharedCollections,
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,

        //*********************************************************/
        components //TODO: Move all from this into separate modules!
        //*********************************************************/
    ],
    entryComponents: [
        components,
        componentsExtra
    ]
})
export class SharedModule { }
